import { render, staticRenderFns } from "./MintingNow.vue?vue&type=template&id=3f19486e&"
import script from "./MintingNow.vue?vue&type=script&lang=js&"
export * from "./MintingNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports